import React, { useState, useEffect } from 'react'
import ResultsTable from '../ui/ResultsTable/ResultsTable'
import PropertyService from '../../services/PropertyService'
import Moment from 'moment'

function createJobItem(
  id,
  dateraised,
  jobtype,
  jobnumber,
  clientjobnumber,
  jobstatus,
  priority,
  targetcompletiondate
) {
  return {
    id,
    dateraised,
    jobtype,
    jobnumber,
    clientjobnumber,
    jobstatus,
    priority,
    targetcompletiondate
  }
}

const JobHistoryTab = ({ propertyId }) => {
  const [jobs, setJobs] = useState([])

  const getJobs = (id) => {
    PropertyService.getJobHistory(id)
      .then((response) => {
        const items = response.value.collection.map((i) =>
          createJobItem(
            i.jobId,
            i.dateRaised
              ? Moment(i.dateRaised).format('DD-MM-YYYY HH:mm')
              : null,
            i.jobType?.literalText,
            i.jobNumber,
            i.clientJobNumber,
            i.jobStatus?.literalText,
            i.priority?.literalText,
            i.targetCompletionDate
              ? Moment(i.targetCompletionDate).format('DD-MM-YYYY HH:mm')
              : null
          )
        )

        setJobs(items)
      })
      .catch((e) => {
        console.log(e)
      })
  }

  useEffect(() => {
    getJobs(propertyId)
  }, [propertyId])

  return (
    <div>
      <ResultsTable
        columns={[
          {
            name: 'id',
            label: 'Id',
            hidden: true
          },
          {
            name: 'dateraised',
            label: 'Date Raised',
            type: 'date'
          },
          {
            name: 'jobtype',
            label: 'Job Type'
          },
          {
            name: 'jobnumber',
            label: 'Job Number'
          },
          {
            name: 'clientjobnumber',
            label: 'Client Job Number'
          },
          {
            name: 'jobstatus',
            label: 'Job Status'
          },
          {
            name: 'priority',
            label: 'Priority'
          },
          {
            name: 'targetcompletiondate',
            label: 'Target Completion Date'
          }
        ]}
        data={jobs}
        baseLink="/job"
        linkKey="id"
        orderBy="dateraised"
        direction="desc"
      ></ResultsTable>
    </div>
  )
}

export default JobHistoryTab
